import styled from 'styled-components';

export const Wrapper = styled.h1`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 36px;
  color: ${({ theme }) => theme.colors.white100};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  line-height: 40px;

  ${({ theme }) => theme.media.mobile} {
    font-size: ${({ theme }) => theme.fontSize.H4};
    line-height: 38px;
    flex-direction: column;
  }

  .slick-slider {
    margin-left: 5px;
  }
  .slick-slide {
    width: auto !important;
    float: none;
    border: 0;
  }
`;
